<div class="fill-parent display-flex flex-col">
    <div class="flex-grow-1 display-flex flex-col">
      <ng-scrollbar class="flex-grow-1 white-back">
        <div>
          <table mat-table [dataSource]="data" matSort
                 matSortActive="firstName" matSortDisableClear matSortDirection="desc"
                 (matSortChange)="sortColumn($event)">
  
            <!-- Position Column -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
              <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
            </ng-container>
  
            <!-- Name Column -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
              <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
            </ng-container>
  
            <!-- Weight Column -->
            <ng-container matColumnDef="jobTitle">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Title </th>
              <td mat-cell *matCellDef="let element"> {{element.jobTitle}} </td>
            </ng-container>
  
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
              <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
            </ng-container>

            <ng-container matColumnDef="export">
              <th mat-header-cell *matHeaderCellDef>
                  <button mat-icon-button color="primary" (click)="exportCSV()">
                    <img src="assets/images/csv.png" width="24" />
                  </button>
              </th>
              <td mat-cell *matCellDef="let element"></td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef>
                    <button mat-icon-button color="primary" (click)="exportCSV()">
                      <img src="assets/images/csv.png" width="24" />
                    </button>
                </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="primary" (click)="deleteContact($event,element)">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="headMasterId">
                <th mat-header-cell *matHeaderCellDef> Head Teacher </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="primary" (click)="assignHeadMaster($event,element)" *ngIf="element.id != headmasterId">
                    <mat-icon>person</mat-icon>
                  </button>

                    <mat-icon *ngIf="element.id == headmasterId" style="width: 40px;height: 40px;text-align: center;line-height: 40px;">check</mat-icon>

                </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['/admin/contacts',row.id]"></tr>
          </table>
        </div>
      </ng-scrollbar>
  
      <div class="grid-pages-cont margin-b-l">
        <mat-paginator #paginator
                       [pageSizeOptions]="[5, 10, 25, 100]"
                       (page)="pageChanged($event)">
        </mat-paginator>
      </div>
  
    </div>
  
  
  </div>
